import Buttons from '../../elements/modal/genericAcceptModalButtons';
import Container from '../../atoms/container/modalContainer';
import FlavourConfig from '../../../../shared/config/flavours';
import Focus from '@shared/types/enums/focus';
import Title from '../../atoms/text/modalTitle';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import { mediaSelector } from '@shared/store/slices/media.slice';
import { modalSelector } from '../../../../shared/store/slices/modal.slice';
import { popRoute } from '../../../../shared/store/thunks/route.thunk';
import { useAppDispatch, useAppSelector } from '../../../../shared/store/hooks';
import { useEffect, useRef, useState } from 'react';
import { setFocus } from '@shared/store/slices/focus.slice';
import {
  channelDown,
  channelUp,
} from '../../../../shared/store/thunks/channels.thunk';

const TIME_TO_REFOCUS = 3000;

function ClosePlayerModal() {
  const dispatch = useAppDispatch();
  const { live } = useAppSelector(mediaSelector);
  const { params } = useAppSelector(modalSelector);
  const [callback, setCallback] = useState<() => void>(() => null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(
    undefined
  );

  /* Workaround in case focus doesn't set correctly in LG monitors */
  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      dispatch(setFocus(Focus.MODAL_BUTTONS));
    }, TIME_TO_REFOCUS);
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  useEffect(() => {
    const { key } = params || {};
    switch (key) {
      case 'CHANNEL_UP':
      case 'UP':
        setCallback(channelUp);
        break;
      case 'CHANNEL_DOWN':
      case 'DOWN':
        setCallback(channelDown);
        break;
      default:
        setCallback(popRoute);
        break;
    }
  }, [params]);

  return (
    <Container id={'closePlayerModalContainer'}>
      <Title>
        {TranslationManager.get(
          'MODAL.CLOSE_PLAYER.TITLE',
          FlavourConfig.appTitle
        )}
      </Title>
      <Buttons
        acceptAction={() => dispatch(callback)}
        cancelAction={() =>
          dispatch(setFocus(live ? Focus.ZAPPER : Focus.PLAYER))
        }
      />
    </Container>
  );
}

export default ClosePlayerModal;
